import { NavLink, Outlet } from "react-router-dom";
import React, { Suspense } from "react";
import kingspan from "../../assets/kingspan_logo_white.svg";
import { Footer } from "@/components/Footer/Footer";
import { useAuth } from "@/authContext";
import { Button } from "@/components/ui/button";
import { Skeleton } from "@/components/ui/skeleton";

const LoadingFallback = () => (
    <div className="flex flex-col gap-4 p-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
    </div>
);

const Layout = () => {
    const { account, logout } = useAuth();

    return (
        <div className="flex h-full flex-col bg-gray-100">
            <header className="bg-kingspan-blue sticky top-0 z-20 select-none text-gray-200 shadow-lg">
                <div className="container mx-auto flex items-center justify-between px-6 py-3 lg:px-8">
                    <NavLink to="/">
                        <img src={kingspan} alt="Kingspan logo" className="h-auto w-32" />
                    </NavLink>
                    <nav>
                        <ul className="flex list-none gap-6 font-medium">
                            <li>
                                <NavLink
                                    to="/"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-kingspan-gold underline decoration-2 underline-offset-4"
                                            : "text-white hover:text-kingspan-gold transition-colors duration-300"
                                    }
                                >
                                    Chat
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/data"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-kingspan-gold underline decoration-2 underline-offset-4"
                                            : "text-white hover:text-kingspan-gold transition-colors duration-300"
                                    }
                                >
                                    Data
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="/help"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-kingspan-gold underline decoration-2 underline-offset-4"
                                            : "text-white hover:text-kingspan-gold transition-colors duration-300"
                                    }
                                >
                                    Help
                                </NavLink>
                            </li>
                        </ul>
                    </nav>
                    <Button variant={"ghost"} onClick={logout}>
                        {`Logout\n${account?.username}`}
                    </Button>
                </div>
            </header>

            <main className="container mx-auto grow p-6">
                <Suspense fallback={<LoadingFallback />}>
                    <Outlet />
                </Suspense>
            </main>

            <footer className="bg-kingspan-blue select-none p-4 text-center text-white shadow-inner">
                <Footer />
            </footer>
        </div>
    );
};

export default Layout;
